import type { PatternTest } from '../model/types';

export const defaultPatternTest: PatternTest = (pattern, text) => {
  let compiled: RegExp;
  try {
    compiled = new RegExp(pattern);
  } catch {
    return true;
  }
  return compiled.test(text);
};
